import React from "react"

import Layout from "../components/allstar/layout"
import SectionHero from "../components/allstar/social-media-templates/section-hero"
import SectionBody from "../components/allstar/social-media-templates/section-body"
import { graphql } from "gatsby"
import { useYear } from "../context/YearContext"

const SocialMediaTemplatesPage = props => {
  const { selectedYear } = useYear()
  return (
    <Layout
      location={props.location}
      title={"Social Media Templates"}
      isResourceSite
    >
      <SectionHero year={selectedYear} data={props.data} />
      <SectionBody
        year={selectedYear}
        data={props.data}
        location={props.location}
      />
    </Layout>
  )
}

export default SocialMediaTemplatesPage

export const query = graphql`
  query socialMediaTemplatesPage {
    allBadges: allFile(
      filter: { relativeDirectory: { eq: "allstar/badges" } }
    ) {
      edges {
        node {
          name
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
  }
`
